var modules_51d8f436 = {"arrow":"_a3tw2d"};
import "../../../assets/C41Mn9O1.css";

export { modules_51d8f436 as default };
//# sourceMappingURL=Pagination.module.less.js.map
